import Alert from 'bootstrap/js/src/alert.js'
import Button from 'bootstrap/js/src/button.js'
import Carousel from 'bootstrap/js/src/carousel.js'
import Collapse from 'bootstrap/js/src/collapse.js'
import Dropdown from 'bootstrap/js/src/dropdown.js'
import Modal from 'bootstrap/js/src/modal.js'
import Offcanvas from 'bootstrap/js/src/offcanvas.js'
import Popover from 'bootstrap/js/src/popover.js'
import ScrollSpy from 'bootstrap/js/src/scrollspy.js'
import Tab from 'bootstrap/js/src/tab.js'
import Toast from 'bootstrap/js/src/toast.js'
// import Tooltip from './src/tooltip'
import Hamburger from './plugins/hamburger.js'
import MobileToggles from './plugins/mobile-toggles.js'
import Search from './plugins/search.js'
import Consent from './plugins/consent.js'
import Overlay from './plugins/overlay.js'
import Social from './plugins/social.js'
import Gallery from './plugins/gallery.js'
import Display from './plugins/display.js'
import Icons from './plugins/icons.js'
import _WideDropdown from './plugins/wide-dropdown.js'

export default {
  MobileToggles,
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  // Tooltip
  Hamburger,
  Search,
  Consent,
  Overlay,
  Social,
  Display,
  Icons,
  Gallery,
  _WideDropdown
}
